import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parses a date string in "YYYY-MM-DD" format as a local date.
 * This avoids timezone issues where "2024-03-19" would be parsed as
 * UTC midnight, which becomes March 18 at 21:00 in Brazil (UTC-3).
 */
export function parseLocalDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year!, month! - 1, day!);
}
